import { MsalAuthProvider, LoginType } from "react-aad-msal";
import {config} from "../config/config";

export const authenticationParameteres = {
    scopes: [
        `${process.env.REACT_APP_AZURE_CLIENT_ID}/.default`
    ],
}

export const authenticationParameteresGraph={
    scopes:[
        "openid"
    ],
}

export const options={
    loginType:LoginType.Redirect,
    tokenRefreshUri:window.location.origin,
}

export const authProvider = new MsalAuthProvider(config,authenticationParameteres,options);